import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Protected } from "@/components/site/Protected";
import Home from "@/pages/Home";
import Clinics from "@/pages/Clinics";
import ClinicPage from "@/pages/ClinicPage";
import Book from "@/pages/Book";
import ForClinics from "@/pages/ForClinics";
import Account from "@/pages/Account";
import Pricing from "@/pages/Pricing";
import Tour from "@/pages/Tour";
import SuperLayout from "@/pages/super/SuperLayout";
import SuperClinics from "@/pages/super/SuperClinics";
import SuperPlans from "@/pages/super/SuperPlans";
import SuperContent from "@/pages/super/SuperContent";
import SuperPayments from "@/pages/super/SuperPayments";
import Billing from "@/pages/admin/Billing";
import Payouts from "@/pages/admin/Payouts";
import { ContentProvider } from "@/context/ContentContext";
import { Login, Signup, ClinicSignup } from "@/pages/Auth";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Appointments from "@/pages/admin/Appointments";
import Services from "@/pages/admin/Services";
import Practitioners from "@/pages/admin/Practitioners";
import Patients from "@/pages/admin/Patients";
import Reports from "@/pages/admin/Reports";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <ContentProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/clinics" element={<Clinics />} />
            <Route path="/clinic/:slug" element={<ClinicPage />} />
            <Route path="/book/:slug" element={<Book />} />
            <Route path="/for-clinics" element={<ForClinics />} />
            <Route path="/for-clinics/signup" element={<ClinicSignup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/payment/success" element={<Protected roles={["patient"]}><PaymentSuccess /></Protected>} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/account" element={<Protected roles={["patient"]}><Account /></Protected>} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/tour" element={<Tour />} />
            <Route path="/super" element={<Protected roles={["super_admin"]}><SuperLayout /></Protected>}>
              <Route index element={<SuperClinics />} />
              <Route path="plans" element={<SuperPlans />} />
              <Route path="content" element={<SuperContent />} />
              <Route path="payments" element={<SuperPayments />} />
            </Route>
            <Route path="/admin" element={<Protected roles={["clinic_owner"]}><AdminLayout /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="appointments" element={<Appointments />} />
              <Route path="services" element={<Services />} />
              <Route path="practitioners" element={<Practitioners />} />
              <Route path="patients" element={<Patients />} />
              <Route path="reports" element={<Reports />} />
              <Route path="settings" element={<Settings />} />
              <Route path="billing" element={<Billing />} />
              <Route path="payouts" element={<Payouts />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-center" />
        </BrowserRouter>
      </AuthProvider>
      </ContentProvider>
    </div>
  );
}

export default App;
